import Insight from "../insightClass";
import React from "react";
import { insight37Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight065 = new Insight(
  "19 September 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight37Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-09-19)",
  "",
  `The Port of Tyne has announced a £150m expansion plan for its Clean Energy Park, aiming to establish itself as a leading offshore wind hub for the UK and Europe. The scheme spans 230 acres and includes 400 metres of deep-water quayside to accommodate next-generation turbines and large foundations. Phase 1, already delivered with £6m invested, features a 23,000 sq ft warehouse and a dedicated berth. `,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-09-19)</h1>
    <h2></h2>
    <p className="article-date">19 September 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>
      1. UK’s Port of Tyne unveils £150m expansion to build a national offshore
      wind hub
    </h3>
    <p>
      The Port of Tyne has announced a £150m expansion plan for its Clean Energy
      Park, aiming to establish itself as a leading offshore wind hub for the UK
      and Europe. The scheme spans 230 acres and includes 400 metres of
      deep-water quayside to accommodate next-generation turbines and large
      foundations. Phase 1, already delivered with £6m invested, features a
      23,000 sq ft warehouse and a dedicated berth. The port projects that the
      expansion will create up to 12,000 jobs and generate £5.6bn in regional
      economic benefits. The announcement comes amid rising costs, tighter
      financing conditions, and uncertainty over CfD auctions. With turbine
      ratings climbing beyond 15–20MW, ports with heavy-lift capacity, bearing
      strength and large marshalling areas will directly influence project
      deliverability.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Ports are now decisive factors in LCOE and bankability. Tyne’s plan
      addresses bottlenecks of quay length, load capacity, crane pathways and
      laydown space. For future CfD bids, developers must secure reliable port
      access early to avoid cost overruns and schedule slippage. Tyne will face
      tough competition from Humber and Tees, and long-term success depends on
      securing anchor tenants and throughput guarantees.
    </p>
    <h3>
      2. Netherlands revives support: €1bn subsidies for 2GW offshore wind
    </h3>
    <p>
      The Dutch government will allocate around €1bn in 2026 to underwrite 2GW
      of offshore wind capacity. This follows the suspension of tenders in May
      due to financing challenges under zero-subsidy models. National targets
      have also shifted, with 21GW now planned by 2032 rather than 2030. The new
      mechanism may take the form of CfD-style revenue floors or hybrids,
      ensuring bankability while maintaining sustainability and local-content
      criteria. Developers such as Eneco and Ørsted are expected bidders.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This marks Europe’s policy recalibration. Risk transfer design will be
      crucial: whether full CfDs or partial guarantees. Developers should test
      IRRs under multiple price scenarios, evaluate OEM supply bottlenecks, and
      assess financing appetite. The Dutch move will pressure Germany and the UK
      to adjust their auction frameworks to retain investment appeal.
    </p>
    <h3>3. Ørsted launches $9.4bn rights issue to stabilise US projects</h3>
    <p>
      Ørsted has launched a $9.4bn rights issue, issuing 901m new shares at DKK
      66.6, a 67% discount to the prior close. The capital will support Sunrise
      Wind in the US and strengthen liquidity, after supply-chain delays, rising
      interest rates and policy volatility undermined its balance sheet. Plans
      for partial asset sales and project finance fell through, forcing the
      equity raise. Rights trading continues until early October, with admission
      by mid-October.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The recapitalisation reduces counterparty risk for suppliers and
      contractors, stabilising project timetables. Shareholders face heavy
      dilution, so Ørsted must demonstrate cash discipline and milestone
      delivery. The raise establishes a valuation floor for capital-intensive
      developers and may reopen stalled US procurement opportunities.
    </p>
    <h3>4. Germany considers CfDs as part of energy market reset</h3>
    <p>
      Germany has outlined plans to introduce Contracts for Difference (CfDs)
      for offshore wind, phasing out fixed-price subsidies under a ten-point
      energy strategy. The framework also includes regional incentives,
      capacity-based grid charges, cable pooling and a capacity market from
      2027. By 2045, transmission investment of €440bn and distribution
      investment of €235bn are projected. The timeline and design of CfDs remain
      under development.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      CfDs will restore bankability, lowering WACC by providing predictable
      revenues. Capacity markets will reduce cannibalisation risks. Developers
      must monitor indexation mechanisms, curtailment liability and stacking of
      CfDs with PPAs. Bids are expected to be more rational, reflecting
      realistic financing assumptions.
    </p>
    <h3>5. US halts Revolution Wind construction, sparking lawsuits</h3>
    <p>
      The US government has ordered Ørsted to halt construction at Revolution
      Wind in Rhode Island, prompting lawsuits from both the developer and the
      states of Rhode Island and Connecticut. At present, four offshore wind
      projects are producing power, with another four under construction. South
      Fork, online since July 2024, delivered a 46.4% capacity factor in its
      first year and 53% in the first half of 2025, comparable with leading New
      York gas plants. The case highlights growing friction between federal
      directives and state-level policy ambitions.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The stop-work order introduces procedural uncertainty, raising EPC
      premiums and financing costs. Yet South Fork’s strong performance
      demonstrates robust post-COD economics. In the near term, WACC will rise
      and timelines may slip, but state governments may offer indemnities to
      maintain momentum.
    </p>
    <h3>6. Australia delays first offshore wind auction</h3>
    <p>
      Australia has postponed its inaugural offshore wind auction, citing
      adverse global conditions and the need for design adjustments. Gippsland
      in Victoria and other declared zones are affected. While Australia holds
      world-class southern coastline resources and enjoys strong state support,
      weak grid capacity and underdeveloped port infrastructure pose risks.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The delay is pragmatic. Without addressing permitting, grid and port
      bottlenecks, early auctions risk stranded awards. A phased approach with
      CfD-style floors, indexed cost adjusters and enforceable local content is
      preferable. Developers should use the delay to secure ports and long-lead
      items. The outcome will be fewer bids short term but greater delivery
      credibility long term.
    </p>
    <h3>
      7. China installs world’s first 26MW offshore turbine, a deep-water
      milestone
    </h3>
    <p>
      China has installed the world’s first 26MW offshore turbine off Shandong,
      using a 4,000-tonne crawler crane to align a 1,000-tonne nacelle with
      millimetre precision. Standing 185 metres tall, the unit is expected to
      generate 100GWh annually, enough to power 55,000 households. The
      installation demonstrates rapid advances in handling ultra-large turbines
      and deep-water logistics.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Although a demonstrator, the project is significant. Constraints are
      shifting from generator efficiency to logistics and port readiness. If
      China industrialises these heavy-lift processes, global cost curves may
      reset. Other markets must prepare for 20MW+ turbines with upgraded ports,
      vessels, and more stringent warranties.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
